import React, { Component } from 'react';
import CopyHtml from '../../common/components/CopyHtml';
import { getCopy } from '../../common/lib/copyDefaults';

import '../../../style/index.css';
import './registrationError.css';

class RegistrationErrorView extends Component {
  componentDidMount() {
    requestAnimationFrame(() => {
      const el = document.getElementById('registration-error-heading');
      if (el) {
        el.focus();
      }
    });
  }

  render() {
    const copy = getCopy('/registration-error');

    return (
      <div className="registration-error row justify-content-center">
        <div className="col-xl-7 col-lg-8 col-md-8 col-sm-10">
          <div className="registration-error__body">
            <h1 id="registration-error-heading" tabIndex={-1} className="registration-error__title">
              {copy.header}
            </h1>
            <p className="registration-error__description">{copy.intro}</p>
            <CopyHtml html={copy.support} className="registration-error__support" />
          </div>
        </div>
      </div>
    );
  }
}

export default RegistrationErrorView;
